module.exports = function() {
  return new Worker(__webpack_public_path__ + "87ac12a6db606cc62e6e.worker.js");
};